/* Dual-handle price range slider that drives Dawn's price-range text inputs.
   Auto-upgrades after AJAX filter re-render because it is a custom element. */
class PriceRangeSlider extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.minInput = this.querySelector('.jm-price-slider__input--min');
    this.maxInput = this.querySelector('.jm-price-slider__input--max');
    this.fill = this.querySelector('.jm-price-slider__fill');
    this.rangeMin = parseFloat(this.dataset.min) || 0;
    this.rangeMax = parseFloat(this.dataset.max) || 0;

    const priceRange = this.closest('price-range');
    const textInputs = priceRange ? priceRange.querySelectorAll('.field__input') : [];
    this.minText = textInputs[0];
    this.maxText = textInputs[1];

    this.minInput.addEventListener('input', () => this.onSlide('min'));
    this.maxInput.addEventListener('input', () => this.onSlide('max'));
    this.minInput.addEventListener('change', () => this.commit());
    this.maxInput.addEventListener('change', () => this.commit());

    if (this.minText) this.minText.addEventListener('change', () => this.syncFromText());
    if (this.maxText) this.maxText.addEventListener('change', () => this.syncFromText());

    this.updateFill();
  }

  onSlide(which) {
    let minV = parseFloat(this.minInput.value);
    let maxV = parseFloat(this.maxInput.value);

    // Prevent the handles from crossing over each other.
    if (minV > maxV) {
      if (which === 'min') {
        minV = maxV;
        this.minInput.value = minV;
      } else {
        maxV = minV;
        this.maxInput.value = maxV;
      }
    }

    // Reflect live into the text inputs (blank = unbounded, so the filter clears).
    if (this.minText) this.minText.value = minV > this.rangeMin ? this.format(minV) : '';
    if (this.maxText) this.maxText.value = maxV < this.rangeMax ? this.format(maxV) : '';

    this.updateFill();
  }

  format(value) {
    return value % 1 === 0 ? String(value) : value.toFixed(2);
  }

  updateFill() {
    const minV = parseFloat(this.minInput.value);
    const maxV = parseFloat(this.maxInput.value);
    const span = this.rangeMax - this.rangeMin || 1;
    const left = ((minV - this.rangeMin) / span) * 100;
    const right = ((maxV - this.rangeMin) / span) * 100;

    if (this.fill) {
      this.fill.style.left = left + '%';
      this.fill.style.right = 100 - right + '%';
    }

    // Keep the min thumb on top when both handles bunch up at the high end.
    this.minInput.style.zIndex = minV > this.rangeMax - span * 0.05 ? 5 : 3;
  }

  commit() {
    // Dispatch on the text inputs so Dawn's PriceRange validates and the
    // facet form's debounced 'input' listener triggers the AJAX re-filter.
    if (this.minText) this.minText.dispatchEvent(new Event('change', { bubbles: true }));
    if (this.maxText) {
      this.maxText.dispatchEvent(new Event('change', { bubbles: true }));
      this.maxText.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  syncFromText() {
    const minV = this.minText && this.minText.value !== '' ? parseFloat(this.minText.value) : this.rangeMin;
    const maxV = this.maxText && this.maxText.value !== '' ? parseFloat(this.maxText.value) : this.rangeMax;
    if (!isNaN(minV)) this.minInput.value = minV;
    if (!isNaN(maxV)) this.maxInput.value = maxV;
    this.updateFill();
  }
}

if (!customElements.get('price-range-slider')) {
  customElements.define('price-range-slider', PriceRangeSlider);
}
